import { getProductName, getProductTitle } from '@ucc/unified-admin-common'

import { TranslateFunction } from 'types/common'

export const getProductFamilyName = (product = ''): string => {
  return getProductName(product)
}

interface GetFullProductNameProps {
  product: string
  t: TranslateFunction
  rebranding?: boolean
}
export const getFullProductName = ({ product, t, rebranding = true }: GetFullProductNameProps): string => {
  return getProductTitle({ product: product, t: t, rebranding })
}
